export default {
  ON_BOARDING_CATALOGS_GENDERS_STATE_MANAGER:
    Symbol.for('ON_BOARDING_CATALOGS_GENDERS_STATE_MANAGER'),
  ON_BOARDING_CATALOGS_SEARCH_GENDERS_REPOSITORY:
    Symbol.for('ON_BOARDING_CATALOGS_SEARCH_GENDERS_REPOSITORY'),
  ON_BOARDING_SEARCH_GENDERS_QUERY: Symbol.for('ON_BOARDING_SEARCH_GENDERS_QUERY'),
};
